import React, { useState } from "react";
import Main from "../../components/layout/Main";

function FaqAndTerms() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How do I join a tournament?",
      answer:
        "You can join tournaments by navigating to the 'Tournaments' section, selecting an active event, and clicking on 'Join Now'.",
    },
    {
      question: "What games are supported on this platform?",
      answer:
        "We currently support popular titles like Fortnite, PUBG, COD, Valorant, and Minecraft. New games are added regularly.",
    },
    {
      question: "How do I stream my gameplay?",
      answer:
        "You can stream using OBS or Streamlabs by linking your Twitch/YouTube account in your profile settings.",
    },
    {
      question: "Is cheating or hacking allowed?",
      answer:
        "No. We have a strict anti-cheat policy. Any user caught using third-party cheats will be permanently banned.",
    },
  ];

  return (
    <Main>
      <section>
        <div className="faq-main-div">
          {/* Heading Section */}
          <div className="faq-heading-div">
            <h1>FAQ & Terms</h1>
            <p>
              Find answers to common questions and review our platform’s terms
              & conditions before playing.
            </p>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
              <h2>Frequently Asked Questions</h2>
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <div
                  className={`faq-item ${openIndex === index ? "open" : ""}`}
                  key={index}
                >
                  <div
                    className="faq-question"
                    onClick={() =>
                      setOpenIndex(openIndex === index ? null : index)
                    }
                  >
                    <h3>{faq.question}</h3>
                    <span>{openIndex === index ? "−" : "+"}</span>
                  </div>
                  {openIndex === index && (
                    <div className="faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Terms Section */}
          <div className="terms-section">
            <h2>Terms & Conditions</h2>
            <ul>
              <li>Players must respect fair play and community rules.</li>
              <li>
                Cheating, exploiting bugs, or using third-party hacks will
                result in a permanent ban.
              </li>
              <li>
                All tournament rewards will be credited to the registered
                account only.
              </li>
              <li>
                Streaming and content must comply with platform guidelines.
              </li>
              <li>
                We reserve the right to modify or update rules without prior
                notice.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </Main>
  );
}

export default FaqAndTerms;
